import { apiConfigs } from "@payping/api";
import { SdkThunkDispatch } from "@payping/redux/reducers";
import { loggedIn } from "@payping/redux/actions";

function forApi(token: string): void {
  apiConfigs.updateConfig({ accessToken: token });
}

function forAll(dispatch: SdkThunkDispatch, token: string, ssoUserInfo?: Record<string, unknown>): void {
  forApi(token);
  dispatch(loggedIn(token, ssoUserInfo));
}

export const setToken = {
  forAll,
  forApi,
};
